import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { ORDER_STATUS_NAME } from '../Utils/Constants/Checkout';

interface CheckoutType {
  order: any;
  setOrder: CallableFunction;
  showPixCode: boolean;
  setShowPixCode: CallableFunction;
  getStatusNameById: (value: number) => void;
  currentCard: any; 
  setCurrentCard: (value: any) => void;
  paymentMethod: any;
  setPaymentMethod: (value: any) => void;
  currentMenuMethod: any;
  setCurrentMenuMethod: (value: any) => void;
  loadingListPaymentMethods: boolean;
  setLoadingListPaymentMethods: (value: any) => void;
  methodCardOnline: any;
  setMethodCardOnline: (value: any) => void;
  showRegisterCard: boolean;
  setShowRegisterCard: (value: any) => void;
  ordersTodayList: any[];
  setOrdersTodayList: (value: any[]) => void;
  awaitingOrPendingCount: number;
  setAwaitingOrPendingCount: (value: number) => void;
}

const CheckoutContext = createContext<CheckoutType | undefined>(undefined);

export const CheckoutProvider = ({ children }: { children: ReactNode }) => {

  const [order, setOrder] = useState(() => {
    const storedOrder = localStorage.getItem('order')
    return storedOrder ? JSON.parse(storedOrder) : null
  })

  const [showPixCode, setShowPixCode] = useState<boolean>(false)
  const [currentCard, setCurrentCard] = useState<any>(null);
  const [paymentMethod, setPaymentMethod] = useState<any>(null);
  const [currentMenuMethod, setCurrentMenuMethod] = useState<number | null>(null);
  const [loadingListPaymentMethods, setLoadingListPaymentMethods] = useState<boolean>(true);
  const [methodCardOnline, setMethodCardOnline] = useState<any>(null);
  const [showRegisterCard, setShowRegisterCard] = useState(false);
  const [ordersTodayList, setOrdersTodayList] = useState<any[]>([]);
  const [awaitingOrPendingCount, setAwaitingOrPendingCount] = useState(0);

  const getStatusNameById = (orderStatusId: number): string | null => {
    return ORDER_STATUS_NAME[orderStatusId] ?? null;
  }

  useEffect(() => {
    if (order) {
      localStorage.setItem('order', JSON.stringify(order));
    } else {
      localStorage.removeItem('order');
    }
  }, [order]);

  return (
    <CheckoutContext.Provider value={{ 
        order, setOrder, 
        showPixCode, setShowPixCode, 
        getStatusNameById, 
        currentCard, setCurrentCard,
        paymentMethod, setPaymentMethod,
        currentMenuMethod, setCurrentMenuMethod,
        loadingListPaymentMethods, setLoadingListPaymentMethods,
        methodCardOnline, setMethodCardOnline,
        showRegisterCard, setShowRegisterCard,
        ordersTodayList, setOrdersTodayList,
        awaitingOrPendingCount, setAwaitingOrPendingCount
      }}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckoutContext = () => {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
